import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {ListItemGraphic as RmwcListItemGraphic} from '@rmwc/list'
import '@rmwc/list/styles'

const theme = ({theme}) => css`
  .mdc-theme--on-${theme} &&& {
    color: var(--mdc-theme-on-${theme});
  }
`

export const listItemGraphicStyles = css`
  margin-right: 1rem;
  ${theme({theme: 'primary'})};
`

const StyledRmwcListItemGraphic = styled(RmwcListItemGraphic)`
  &&& {
    ${listItemGraphicStyles}
  }
`

const ListItemGraphic = ({children, ...otherProps}) => <StyledRmwcListItemGraphic {...otherProps}>{children}</StyledRmwcListItemGraphic>

ListItemGraphic.propTypes = {
  children: PropTypes.any
}

export {ListItemGraphic}
